'use client'

import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { AppleHelloIntro } from './apple-hello-intro'
import { useIntroState } from '@/hooks/use-intro-state'

interface IntroOverlayProps {
  children: React.ReactNode
  forceShow?: boolean
  language?: 'english' | 'vietnamese' | 'both'
}

export function IntroOverlay({ 
  children, 
  forceShow = false,
  language = 'english' 
}: IntroOverlayProps) {
  const { hasSeenIntro, isLoading, markIntroAsSeen } = useIntroState()
  const [showIntro, setShowIntro] = useState<boolean>(false)

  useEffect(() => {
    // Render hero immediately; only show intro when explicitly forced and the user hasn't seen it
    setShowIntro(forceShow && hasSeenIntro === false)
  }, [hasSeenIntro, forceShow])

  const handleIntroComplete = () => {
    markIntroAsSeen()
    setShowIntro(false)
  }

  const handleSkip = () => {
    markIntroAsSeen()
    setShowIntro(false)
  }



  return (
    <>
      <AnimatePresence>
        {showIntro && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{
              duration: 1.2,
              ease: "easeInOut"
            }}
          >
            <AppleHelloIntro
              onComplete={handleIntroComplete}
              onSkip={handleSkip}
              showSkipButton={true}
              language={language}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: showIntro ? 0 : 1, scale: showIntro ? 1.02 : 1 }}
        animate={{ opacity: showIntro ? 0 : 1, scale: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeOut"
        }}
        style={{ pointerEvents: showIntro ? 'none' : 'auto' }}
      >
        {children}
      </motion.div>
    </>
  )
}
